import React from "react";
import Searchbox from "@/Components/Searchbox";
import Chip from "@/Components/Chip";

export default function PeopleHeader({addPersonSlider,
                                         addFilterSlider,
                                         statusItems,
                                         setStatusItems,
                                         accountTypeItems,
                                         setAccountTypeItems,
                                         moduleAccessItems,
                                         setModuleAccessItems,
                                         state,
                                         dispatch}) {

    return (
        <div className="row people-header">
            <div className="search-and-filter">
                <Searchbox placeholder="Search for a person"
                            onSearchChange={e => {
                                dispatch({ type: "searchValue", payload: { searchValue: e.target.value }});
                            }}
                            state={state}
                            dispatch={dispatch}
                            dataTestid="people_header-input-search"
                />
                <i className="fas fa-filter" data-testid="people_header-i-filter_icon"
                   onClick={addFilterSlider} />
            </div>
            <div className="add">
                <button className="btn btn-sm btn-primary flex" onClick={addPersonSlider} data-testid="person_header-button-add_button">
                    <i className="far fa-plus" data-testid="person_header-i-add_button_icon"></i>
                    <span data-testid="person_header-span-add_button_text">Add</span>
                </button>
            </div>
            {state.filters.length > 0 ?
                <div className="filter-chips">
                    {state.filters.map((filter, index) =>
                        <Chip key={index}
                              label={filter}
                              color="secondary"
                              onDelete={() => {
                                  const updatedFilters = state.filters.filter(i => i !== filter);
                                  dispatch({ type: "filters", payload: { filters: updatedFilters } });
                                  setStatusItems(statusItems.map(item => {
                                      return item.id === filter ? { ...item, checked: false, } : item;
                                  }));
                                  setAccountTypeItems(accountTypeItems.map(item => {
                                      return item.id === filter ? { ...item, checked: false, } : item;
                                  }));
                                  setModuleAccessItems(
                                    moduleAccessItems.map((item) => {
                                        // Compare filter with the module's label instead of its id
                                        return item.label === filter ? { ...item, checked: false, } : item
                                  }));
                              }}
                        />
                    )}
                </div>
                : null}
        </div>
    );
}
